import groupPath from '../../utils/url/groupPath';
import postPath from '../../utils/url/postPath';
import topicPath from '../../utils/url/topicPath';
import userPath from '../../utils/url/userPath';
import EDITOR_INTEGRATION_MENTIONS from '../mentions/EditorIntegrationMentions';
import type { Mention } from '../types';
import { parsePostMentionId } from './matchMention';

const toFullUrl = (path: string) =>
  `${document.location.protocol}//${document.location.host}${path}`;

const getEditorMentionUrl = ({
  id,
  type,
  content,
  params,
}: {
  id: string;
  type: string;
  content?: string;
  params?: Mention['params'];
}) => {
  switch (type) {
    case 'post': {
      const { id: postId, anchor } = parsePostMentionId(id);
      return toFullUrl(postPath({ id: postId, title: content || '' }, anchor));
    }
    case 'user':
      return toFullUrl(userPath({ id, name: content || '' }));
    case 'group':
      return toFullUrl(groupPath({ id, name: content || '' }));
    case 'topic':
      return toFullUrl(topicPath({ id, name: content || '' }));
    case 'external-post':
      return '';
    default: {
      const paramsObject = Object.fromEntries(new URLSearchParams(params));
      return (
        EDITOR_INTEGRATION_MENTIONS[type]?.buildUrl(id, paramsObject) || ''
      );
    }
  }
};

export default getEditorMentionUrl;
